import { CaretRightIcon } from '@phosphor-icons/react';
import type { EventSeriesBannerProps } from '@/lib/types/events.types';
import { EventDetailsContent } from '@/content/EventDetailsContent';

interface EventSeriesBannerInternalProps extends EventSeriesBannerProps {
  /** Current event position in the series (1-indexed) */
  currentPosition: number;
  /** Total number of events in the series */
  totalEvents: number;
}

export function EventSeriesBanner({
  currentPosition,
  totalEvents,
  onClick,
}: EventSeriesBannerInternalProps) {
  return (
    <button
      onClick={onClick}
      data-testid="event-series-banner"
      className="w-full flex items-center justify-between mt-4 pt-4 bg-slate-700/30 backdrop-blur-lg rounded-lg p-4 shadow-lg"
      aria-label={EventDetailsContent.seriesBanner.ariaLabel}
    >
      <div className="flex flex-col items-start">
        <span className="text-small text-purple-300">
          {EventDetailsContent.seriesBanner.label}
        </span>
        <span className="text-large text-slate-50">
          Event {currentPosition} of {totalEvents}
        </span>
      </div>
      <CaretRightIcon size={20} weight="bold" className="text-purple-300" />
    </button>
  );
}

